export default __webpack_public_path__ + "static/media/logoM.ae596478.svg";